/**
 * @generated SignedSource<<9d2a81a78e6510651f442349c61b5364>>
 * @relayHash cf0d2832fbc80d62e731148ccc155429
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf0d2832fbc80d62e731148ccc155429

import { ConcreteRequest } from 'relay-runtime';
export type BetterDocRejectionReason = "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND" | "PATIENT_REFUSES_TO_USE_BETTER_DOC";
export type De_confirmBetterDocRejectionInput = {
  betterDocRejectionReason: BetterDocRejectionReason;
  id: string;
};
export type deConfirmBetterDocRejectionMutation$variables = {
  input: De_confirmBetterDocRejectionInput;
};
export type deConfirmBetterDocRejectionMutation$data = {
  readonly confirmBetterDocRejection: {
    readonly ProgressNoteMutationOutput: {
      readonly progressNote: {
        readonly betterDoc: {
          readonly rejectionReason: BetterDocRejectionReason | null;
        } | null;
        readonly id: string;
        readonly updatedAt: string;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deConfirmBetterDocRejectionMutation = {
  response: deConfirmBetterDocRejectionMutation$data;
  variables: deConfirmBetterDocRejectionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": "ProgressNoteMutationOutput",
  "args": null,
  "concreteType": "de_ProgressNoteMutationOutput",
  "kind": "LinkedField",
  "name": "de_ProgressNoteMutationOutput",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "de_ProgressNote",
      "kind": "LinkedField",
      "name": "progressNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "de_ProgressNoteBetterDoc",
          "kind": "LinkedField",
          "name": "betterDoc",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rejectionReason",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deConfirmBetterDocRejectionMutation",
    "selections": [
      {
        "alias": "confirmBetterDocRejection",
        "args": (v1/*:: as any*/),
        "concreteType": "De_confirmBetterDocRejectionPayload",
        "kind": "LinkedField",
        "name": "de_confirmBetterDocRejection",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deConfirmBetterDocRejectionMutation",
    "selections": [
      {
        "alias": "confirmBetterDocRejection",
        "args": (v1/*:: as any*/),
        "concreteType": "De_confirmBetterDocRejectionPayload",
        "kind": "LinkedField",
        "name": "de_confirmBetterDocRejection",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "cf0d2832fbc80d62e731148ccc155429",
    "metadata": {},
    "name": "deConfirmBetterDocRejectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "80ebd40c7ca285aa32fc26f4a2e89a96";

export default node;
